import React from 'react'
import { HubStartupOpportunityFeature } from 'domain/feature/hub/startup/opportunity'

export const HubStartupOpportunityPage = (): JSX.Element => {
  return <HubStartupOpportunityFeature />
}
